import {createSelector} from 'reselect';

import {OrderLastType} from 'desktop/pages/success/types/types';
import {ApplicationStoreType} from 'desktop/store';

import {MODULE_KEY_SUCCESS} from '../../constants';

/**
 * Returns information about latest order
 * @param {ApplicationStoreType} state - store state
 * @return {OrderLastType} - OrderLast data
 */
export const getOrderLastData = (state: ApplicationStoreType): OrderLastType =>
    state[MODULE_KEY_SUCCESS].orderLast;

/**
 * Returns trustpilotQueryString
 * @returns {string} trustpilot query string
 */
export const getTrustpilotQueryString = createSelector(
    getOrderLastData,
    orderLast => orderLast.trustpilotQueryString,
);

/**
 * Returns custom full name
 */
export const getCustomerFullName = createSelector(
    getOrderLastData,
    ({shipping_address: {firstname, lastname}}) =>
        firstname && lastname ? `${firstname} ${lastname}` : '',
);

/**
 * Find if user has the order before by orderId
 *
 * @param {ApplicationStoreType} store - Application store
 * @returns {boolean} - state of existedOrderBeforeToday
 */
export const getExistedOrderBeforeToday = (store: ApplicationStoreType): boolean =>
    store[MODULE_KEY_SUCCESS].orderLast.existedOrderBeforeToday;

/**
 * Returns is popup loading
 * @returns {boolean} is loading
 */
export const getIsPopupLoading = createSelector(getOrderLastData, ({isLoading}) => isLoading);

/**
 * Returns active review popup on TYP
 * @returns {string} active popup
 */
export const getActivePopup = createSelector(getOrderLastData, ({selectedPopup}) => selectedPopup);

/**
 * Returns order tracking token
 * @returns {string} token
 */
export const getOrderTrackingToken = createSelector(
    getOrderLastData,
    ({trackingToken}) => trackingToken,
);
